import { Contact, ContactType } from 'src/types';
import { ReactComponent as EmailIcon } from 'src/assets/email_alt.svg';
import { ReactComponent as PhoneIcon } from 'src/assets/phone.svg';
import { ReactComponent as LinkIcon } from 'src/assets/link.svg';

interface EventContactProps {
  contact: Contact;
  className?: string;
}

export default function EventContact({ contact, className }: Readonly<EventContactProps>) {
  const getIcon = () => {
    switch (contact.contactType) {
      case ContactType.Email:
        return <EmailIcon />;
      case ContactType.Phone:
        return <PhoneIcon />;
      case ContactType.Link:
        return <LinkIcon />;
      default:
        return null;
    }
  };

  return (
    <div className={className ?? ''}>
      {getIcon()}
      <p>{contact.value}</p>
    </div>
  );
}
